function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { mentionLinkResolver } from './mention-link';
import { attachmentLinkResolver } from './attachment-link';
import { urlLinkResolver } from './url-link';
import { issueLinkResolver } from './issue-link';

/**
 * Given some parsed link text, convert it into a link object that can then be rendered into
 * the page.  The parseAsContentLink() method must have been called on the GenericLinkParser
 * object before being passed to this method.
 *
 * @param context    The render context
 * @param parsedLink The parsed link information
 * @return the corresponding link. If no link can be created, null is returned
 */

// jira-components/jira-core/src/main/resources/system-contentlinkresolvers-plugin.xml
// attachment resolver: 10
// anchor resolver: 20 - unsupported
// jiraissue resolver: 30 - unsupported
// user profile: 40
//
// Fall back to url link resolver
var linkResolverStrategies = [attachmentLinkResolver, mentionLinkResolver, issueLinkResolver, urlLinkResolver];
export function resolveLink(link, schema, context) {
  var length = link.originalLinkText.length + 2;
  var _iterator = _createForOfIteratorHelper(linkResolverStrategies),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var resolver = _step.value;
      var resolvedLink = resolver(link, schema, context);
      if (resolvedLink) {
        return {
          length: length,
          nodes: resolvedLink,
          type: 'pmnode'
        };
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return undefined;
}